import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { Confirm, ConfirmOption } from '../../../models/confirm';
import { SafePipe } from '../../../pipes/safe.pipe';

@Component({
    selector: 'app-modal-confirm',
    templateUrl: './modal-confirm.component.html',
    styleUrls: ['./modal-confirm.component.scss'],
    imports: [SafePipe],
})
export class ModalConfirmComponent {

  confirm: Confirm | null = null;
  public onClose: Subject<boolean>;

  constructor(public bsModalRef: BsModalRef) {
    this.onClose = new Subject();
  }

  action(option: ConfirmOption): void {
    this.onClose.next(option.value);
    this.bsModalRef?.hide();
  }

  close() {
    this.bsModalRef?.hide();
  }

}
